import { AuthContext, AuthUi, getAccessToken } from '@biniyog/auth-ui';
import { logEventWithUtcTime } from '@biniyog/firebase';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { get } from './http';

export interface ScaffoldProps {
  children?: React.ReactNode;
}

export const Scaffold: React.FC<ScaffoldProps> = (props) => {
  const [access_token, setAccessToken] = useState<string>();
  const [user, setUser] = useState<Partial<any>>();
  const [authError, setAuthError] = useState<any>();
  const [isRememberMe, setIsRememberMe] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setTimeout(() => {
      if (localStorage.getItem('remember') === 'true') {
        const access_token = getAccessToken();

        if (access_token) {
          setAccessToken(access_token);
        }
      }
    }, 100);
  }, []);

  useEffect(() => {
    const sessionToken = sessionStorage.getItem('access_token');
    const token = sessionToken || access_token;
    if (token) {
      if (!sessionToken) {
        localStorage.setItem('access_token', token);
      }
      (async () => {
        const res = await get(`${process.env.NX_SECURITY_BASE_URL}/auth/user-details`);
        if (res.ok) {
          const data = await res.json();
          setUser(data);
          logEventWithUtcTime('APP_LOAD', { user_id: data?.uuid, user_uuid: data?.uuid });
        }
      })();
    } else {
      // logout...
      setUser(undefined);
      setLoading(false);
    }
    /* eslint-disable-next-line */
  }, [access_token]);

  useEffect(() => {
    if (loading) {
      return;
    }

    const event = new CustomEvent('LOGGED_IN_STATUS', { detail: { loggedIn: access_token !== undefined } });
    document.dispatchEvent(event);
  }, [access_token, loading]);

  if (loading) {
    return <div></div>;
  }

  return (
    <AuthContext.Provider
      value={{ user, access_token, setAccessToken, setUser, setIsRememberMe, setAuthError, authError }}
    >
      {user ? props.children : <AuthUi />}
      {/*{user && (*/}
      {/*  <button*/}
      {/*    onClick={() => {*/}
      {/*      localStorage.removeItem('access_token');*/}
      {/*      window.location.replace('/');*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    Log out*/}
      {/*  </button>*/}
      {/*)}*/}
    </AuthContext.Provider>
  );
};

export default Scaffold;

let watch;
const startWatch = () => {
  let i = 1 * 60 * 60;
  // let i = 20;
  watch = setInterval(() => {
    i--;
    if (i === 0) {
      clearInterval(watch);
      // logout this guy
      localStorage.removeItem('access_token');
      window.location.replace('/');
    }
  }, 1000);
};

const onmousemove = () => {
  clearInterval(watch);
  watchAgain();
};

const watchAgain = debounce(startWatch, 1000);

document.addEventListener(
  'LOGGED_IN_STATUS',
  (e) => {
    const loggedIn = e['detail']['loggedIn'];
    if (loggedIn) {
      startWatch();
      document.addEventListener('mousemove', onmousemove);
    } else {
      clearInterval(watch);
      document.removeEventListener('mousemove', onmousemove);
    }
  },
  false
);
